import React, { forwardRef } from "react";
import { Button, IButtonProps } from "./Button";
import Box from "../box/Box";

type _ButtonProps = Omit<
  IButtonProps,
  "loadingText" | "isFullWidth" | "leftIcon" | "rightIcon" | "iconSpacing" | "children"
>;

interface IIconButtonProps {
  /**
   * The icon to be used in the button.
   */
  icon?: React.ComponentType;
  /**
   * If `true`, the button will be perfectly round. Else, it'll be slightly round
   */
  isRound?: boolean;
  /**
   * A11y: A label that describes the button
   */
  "aria-label": string;
}

export type IconButtonProps = IIconButtonProps & _ButtonProps;

const IconButton: React.FC<IconButtonProps> = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, isRound, "aria-label": ariaLabel, ...rest }, ref) => {
    // Remove some props before passing it to IconButton
    // @ts-ignore
    // eslint-disable-next-line
    const { isFullWidth, leftIcon, rightIcon, loadingText, ...props } = rest;
    // @ts-ignore
    const Icon = <Box as={icon} aria-hidden={true} focusable="false" color="currentColor" />;

    return (
      <Button p={0} borderRadius={isRound ? "full" : "md"} ref={ref} aria-label={ariaLabel} {...props}>
        {Icon}
      </Button>
    );
  },
);

IconButton.displayName = "IconButton";

IconButton.defaultProps = Button.defaultProps;

export default IconButton;
